// The words of the customer portal, Dutch: the source (apps/backoffice/CLAUDE.md "Language & i18n" holds
// here too — code in English, every text through t(), all three files). Flat keys; a count takes _one /
// _other. The customer is addressed with "u". The texts follow docs/design_handoff_partner/.

export const nl = {
  "portal.name": "Klantenportaal",

  "common.cancel": "Annuleren",
  "common.save": "Opslaan",
  "common.copy": "Kopiëren",
  "common.copied": "Gekopieerd",
  "common.backToSignIn": "Terug naar inloggen",

  "language.choose": "Taal kiezen",

  "nav.label": "Portaal",
  "nav.home": "Naar Zendingen",
  "nav.shipments": "Zendingen",
  "nav.order": "Order invoeren",
  "nav.stock": "Voorraad",
  "nav.warehouseOrders": "Magazijnorders",

  "login.title": "Inloggen",
  "login.lead": "Klantenportaal van Willems Logistics",
  "login.email": "E-mailadres",
  "login.password": "Wachtwoord",
  "login.forgot": "Wachtwoord vergeten?",
  "login.submit": "Inloggen",
  "login.noAccount": "Nog geen account? Uw contactpersoon bij Willems nodigt u uit.",

  "code.title": "Code uit de app",
  "code.lead": "Open de authenticator-app en typ de code bij Willems Logistics.",
  "code.leadApp": "Open de app. Onder Willems Logistics staat een code van zes cijfers.",
  "code.label": "Code uit de app",
  "code.noPhone": "Telefoon niet bij de hand? Gebruik een herstelcode",
  "code.changes": "De code verandert elke 30 seconden. Een code die net is verlopen, werkt ook nog.",
  "code.timeTip": "Code klopt niet? Kijk of de tijd op uw telefoon automatisch wordt ingesteld. Staat hij met de hand, dan loopt de code achter.",
  "code.scanAgain": "Opnieuw scannen",
  "code.confirm": "Bevestigen",

  "recovery.back": "Terug naar de code",
  "recovery.title": "Inloggen met een herstelcode",
  "recovery.lead": "Gebruik een van de acht codes die u bewaarde toen u uw account activeerde. Elke code werkt één keer.",
  "recovery.label": "Herstelcode",
  "recovery.thenPhone": "Na het inloggen vraagt het portaal u meteen een nieuwe telefoon te koppelen. Uw oude koppeling vervalt dan.",
  "recovery.noneLeft":
    "Geen codes meer? Neem contact op met uw contactpersoon bij Willems. Willems stelt uw toegang opnieuw in: u krijgt een nieuwe uitnodiging en kiest opnieuw een wachtwoord en een telefoon.",

  "locked.title": "Even dicht",
  "locked.text": "Uw account is een kwartier dicht. Er is vijf keer achter elkaar een verkeerd wachtwoord of een verkeerde code ingevoerd. Inloggen kan weer om {{time}}.",
  "locked.notYou": "Was u dat niet zelf? Wijzig dan na het inloggen uw wachtwoord, via het menu onder uw naam.",

  "forgot.title": "Wachtwoord vergeten",
  "forgot.lead": "U krijgt een mail met een link om een nieuw wachtwoord te kiezen.",
  "forgot.submit": "Link versturen",
  "forgot.sent": "Kijk in uw mail. Is dit adres bij ons bekend, dan staat de link er binnen een paar minuten. Hij werkt een uur. Geen mail? Kijk ook bij ongewenste mail.",
  "forgot.codeToo": "Voor het nieuwe wachtwoord vraagt het portaal ook de code uit uw authenticator-app. Een mailbox alleen is dus niet genoeg om in uw account te komen.",

  "reset.title": "Nieuw wachtwoord",
  "reset.submit": "Opslaan en inloggen",
  "reset.elsewhere": "Na het opslaan wordt u overal anders uitgelogd.",
  "reset.noPhone": "Telefoon ook kwijt? Dan kunt u hier geen nieuw wachtwoord kiezen. Uw contactpersoon bij Willems stelt uw toegang opnieuw in.",

  "link.invalidTitle": "Deze link werkt niet meer",
  "link.invalidInvitation":
    "De link in de uitnodiging werkt één keer, zeven dagen lang. Is uw account al ingesteld? Log dan in. Anders vraagt u uw contactpersoon bij Willems om een nieuwe uitnodiging.",
  "link.invalidReset": "De link voor een nieuw wachtwoord werkt één keer, een uur lang. Vraag een nieuwe link aan.",
  "link.toSignIn": "Naar inloggen",
  "link.askNew": "Nieuwe link vragen",

  "password.new": "Nieuw wachtwoord",
  "password.current": "Huidig wachtwoord",
  "password.repeat": "Nog een keer",
  "password.ruleLength": "Minstens 10 tekens",
  "password.ruleEmail": "Niet uw e-mailadres",
  "password.tooShort": "Kies een wachtwoord van minstens 10 tekens.",
  "password.sameAsEmail": "Uw e-mailadres kan geen wachtwoord zijn.",
  "password.sameAsCurrent": "Kies een ander wachtwoord dan het huidige.",
  "password.notSame": "De twee wachtwoorden zijn niet gelijk.",

  "activate.label": "Account activeren",
  "activate.steps": "Stappen",
  "activate.stepPassword": "Wachtwoord",
  "activate.stepApp": "App koppelen",
  "activate.stepCode": "Code controleren",
  "activate.stepCodes": "Herstelcodes",
  "activate.passwordTitle": "Kies een wachtwoord",
  "activate.passwordLead": "Voor {{email}} · {{companies}}",
  "activate.passwordTip": "Tip: een zin van een paar woorden onthoudt u makkelijker dan een code.",
  "activate.startedBefore": "U was hier al eerder begonnen. Kies opnieuw een wachtwoord; daarna koppelt u de app.",
  "activate.nextApp": "Volgende: app koppelen",
  "activate.nextCode": "Volgende: code controleren",
  "activate.codeTitle": "Typ de code uit de app",
  "activate.linked": "De app is gekoppeld.",
  "activate.toPortal": "Naar het portaal",

  "app.title": "Koppel de authenticator-app op uw telefoon",
  "app.lead": "Bij elke keer inloggen vraagt het portaal een code van zes cijfers uit deze app. Zo kan niemand anders inloggen, ook niet met uw wachtwoord.",
  "app.step1": "Installeer een authenticator-app",
  "app.step1Help": "Bijvoorbeeld Microsoft Authenticator of Google Authenticator: gratis in de App Store of Google Play. Heeft u er al een, gebruik die dan.",
  "app.step2": "Tik in de app op +",
  "app.step2Help": "Kies Account toevoegen en daarna QR-code scannen. Staat er werk- of schoolaccount, kies dan ander account.",
  "app.step3": "Richt de camera op de QR-code hiernaast",
  "app.step3Help": "In de app verschijnt Willems Logistics met een code van zes cijfers.",
  "app.keyDesk": "Lukt scannen niet? Kies in de app code invoeren en typ deze sleutel over:",
  "app.keyPhone": "Gebeurt er niets? Kopieer de sleutel en plak hem in de app bij code invoeren:",
  "app.phoneInstall": "Installeer Microsoft Authenticator of Google Authenticator, als u die nog niet heeft.",
  "app.phoneAdd": "Toevoegen aan de authenticator-app",
  "app.phoneBack": "Kom daarna terug naar dit scherm en typ de code van zes cijfers.",
  "app.qrLabel": "QR-code om het account aan de authenticator-app toe te voegen",
  "app.print": "Deze uitleg afdrukken",

  "codes.title": "Bewaar uw herstelcodes",
  "codes.lead": "Raakt u uw telefoon kwijt, of krijgt u een nieuwe? Dan logt u in met een van deze codes, en koppelt u daarna de nieuwe telefoon. Elke code werkt één keer.",
  "codes.leadNew": "Dit zijn uw nieuwe herstelcodes. De codes van hiervoor werken niet meer. Elke code werkt één keer.",
  "codes.listLabel": "Herstelcodes",
  "codes.download": "Downloaden",
  "codes.print": "Afdrukken",
  "codes.where":
    "Bewaar ze niet alleen op dezelfde telefoon: in de la bij uw bureau, of in de wachtwoordkluis van uw bedrijf. U ziet ze hier maar één keer; nieuwe maken kan later in het menu onder uw naam.",
  "codes.kept": "Ik heb mijn herstelcodes bewaard",
  "codes.noneLeft": "Geen codes meer en telefoon kwijt? Dan stelt Willems uw toegang opnieuw in.",
  "codes.fileName": "willems-herstelcodes.txt",
  "codes.fileHead": "Willems Logistics - klantenportaal",
  "codes.fileFor": "Herstelcodes voor {{email}}",
  "codes.fileMade": "Gemaakt op {{at}}",
  "codes.fileOnce": "Elke code werkt één keer.",

  "phone.title": "Koppel een nieuwe telefoon",
  "phone.stepLabel": "Nieuwe telefoon",
  "phone.lead": "Uw huidige telefoon blijft werken tot de code van de nieuwe telefoon klopt.",
  "phone.leadForced": "U logde in met een herstelcode. Koppel nu de telefoon waarmee u voortaan inlogt; de oude koppeling vervalt dan.",
  "phone.leadPassword": "Typ eerst uw wachtwoord. Uw huidige telefoon blijft werken tot de code van de nieuwe telefoon klopt.",
  "phone.next": "Volgende: app koppelen",
  "phone.done": "De nieuwe telefoon is gekoppeld. Op andere apparaten bent u uitgelogd.",
  "phone.doneTitle": "Klaar",
  "phone.doneLead_one": "U heeft nog {{count}} herstelcode. Maak nieuwe codes via het menu onder uw naam.",
  "phone.doneLead_other": "U heeft nog {{count}} herstelcodes. Nieuwe maken kan in het menu onder uw naam.",

  "company.title": "Voor welk bedrijf werkt u nu?",
  "company.lead_one": "U heeft toegang voor {{count}} bedrijf.",
  "company.lead_other": "U heeft toegang voor {{count}} bedrijven. U ziet steeds één bedrijf tegelijk; wisselen kan bovenin, naast uw naam.",
  "company.signedInAs": "Ingelogd als {{name}} · {{email}}",
  "company.switch": "Ander bedrijf kiezen",
  "company.youWorkFor": "U werkt voor",
  "company.switchNote": "Wisselen laadt het portaal opnieuw, met alleen de gegevens van dat bedrijf.",

  "user.menu": "Gebruikersmenu",
  "user.language": "Taal",
  "user.password": "Wachtwoord wijzigen",
  "user.phone": "Nieuwe telefoon koppelen",
  "user.recoveryCodes": "Nieuwe herstelcodes",
  "user.signOut": "Uitloggen",

  "account.passwordDone": "Uw wachtwoord is gewijzigd. Op andere apparaten bent u uitgelogd.",
  "account.passwordElsewhere": "Na het opslaan wordt u overal anders uitgelogd.",
  "account.backToPortal": "Terug naar het portaal",
  "account.codesLead_one": "U heeft nog {{count}} herstelcode. Maak acht nieuwe; die ene werkt daarna niet meer.",
  "account.codesLead_other": "U heeft nog {{count}} herstelcodes. Maak acht nieuwe; de codes die u nu heeft, werken daarna niet meer.",
  "account.codesSubmit": "Nieuwe codes maken",

  "expired.title": "U bent uitgelogd",
  "expired.text": "Na 8 uur logt het portaal u uit, en ook als uw wachtwoord of toegang is gewijzigd.",
  "expired.again": "Opnieuw inloggen",

  "problem.notFound": "Deze pagina is er niet, of u heeft er geen toegang toe",
  "problem.notFoundText": "Kwam u via een link van een collega? Dan hoort die misschien bij een ander bedrijf.",
  "problem.toShipments": "Naar Zendingen",
  "problem.failure": "Er ging iets mis bij Willems",
  "problem.failureText": "Probeer het opnieuw. Lukt het niet, neem dan contact op met uw contactpersoon.",
  "problem.failureCode": "Probeer het opnieuw. Lukt het niet, noem dan code {{code}} aan uw contactpersoon.",
  "problem.retry": "Opnieuw proberen",

  "shipment.eyebrow": "Zending",
  "shipment.yourReference": "Uw referentie {{reference}}",
  "shipment.entered.portal": "Ingevoerd in het portaal, {{at}}",
  "shipment.entered.edi": "Binnengekomen via EDI, {{at}}",
  "shipment.entered.willems": "Ingevoerd door Willems, {{at}}",
  "shipment.ownPage": "Eigen pagina",
  "shipment.close": "Sluiten",
  "shipment.status.waiting": "Wacht op Willems",
  "shipment.status.rejected": "Afgewezen",
  "shipment.status.confirmed": "Bevestigd",
  "shipment.status.planned": "Ingepland",
  "shipment.status.in_transit": "Onderweg",
  "shipment.status.delivered": "Afgeleverd",
  "shipment.status.refused": "Geweigerd",
  "shipment.status.cancelled": "Geannuleerd",
  "shipment.issue.shortage": "Manco",
  "shipment.issue.damage": "Schade",
  "shipment.waiting.title": "Willems bekijkt deze order voordat hij doorgaat.",
  "shipment.waiting.address": "Een adres is nieuw voor Willems. Willems controleert het en legt het vast.",
  "shipment.waiting.stops": "De volgorde van laden en lossen klopt niet. Willems past het aan of neemt contact met u op.",
  "shipment.waiting.duplicate": "Er lijkt al een gelijke order te zijn. Willems kijkt of het om dezelfde gaat.",
  "shipment.waiting.too_late": "De order kwam na de uiterste invoertijd binnen. Willems kijkt of het nog lukt.",
  "shipment.waiting.account": "Uw bedrijf staat nog niet helemaal klaar bij Willems. Willems regelt dat en zet de order dan door.",
  "shipment.waiting.change": "Er is een wijziging binnengekomen die Willems nog bekijkt.",
  "shipment.waiting.announced": "De order is aangekondigd. Willems wacht op de definitieve gegevens.",
  "shipment.waiting.check": "Willems controleert de order.",
  "shipment.rejected": "Willems kan deze order niet uitvoeren. Neem contact op met uw contactpersoon.",
  "shipment.cancelled": "Deze zending is geannuleerd.",
  "shipment.refused": "De ontvanger heeft de lading geweigerd.",
  "shipment.issueSentence.shortage": "Afgeleverd met een manco.",
  "shipment.issueSentence.damage": "Afgeleverd met schade.",
  "shipment.remark": "Toelichting: {{remark}}",
  "shipment.late": "Afgeleverd na het venster.",
  "shipment.afterWindow": "na het venster",
  "shipment.progress": "Verloop",
  "shipment.step.entered": "Ingevoerd",
  "shipment.step.confirmed": "Bevestigd",
  "shipment.step.planned": "Ingepland",
  "shipment.step.loaded": "Geladen",
  "shipment.step.delivered": "Afgeleverd",
  "shipment.step.completed": "Afgerond",
  "shipment.load": "Laden",
  "shipment.unload": "Lossen",
  "shipment.placeReference": "Referentie {{reference}}",
  "shipment.loadedAt": "Geladen {{at}}",
  "shipment.deliveredAt": "Gelost {{at}}",
  "shipment.cargo.title": "Lading",
  "shipment.cargo.description": "Omschrijving",
  "shipment.cargo.pallets": "Pallets",
  "shipment.cargo.weight": "Gewicht",
  "shipment.cargo.loadingMeters": "Laadmeters",
  "shipment.cargo.adr": "ADR",
  "shipment.cargo.yes": "Ja",
  "shipment.cargo.temperature": "Temperatuur",
  "shipment.documents": "Documenten",
  "shipment.cmrNotYet": "CMR nog niet binnen",
  "shipment.cmrAfterDelivery": "De afgetekende CMR staat hier na het afleveren.",
  "shipment.cmrAfterHandIn": "De afgetekende CMR staat hier zodra hij bij Willems binnen is.",
  "shipment.cmrSigned": "Afgetekende CMR",
  "shipment.packingSlip": "Pakbon",
  "shipment.slipStoring": "wordt opgeslagen…",
  "shipment.slipHelp": "Een pdf tot 10 MB, hoogstens twee per zending, tot de zending gelost is.",
  "shipment.slipClosed": "Deze zending is al gelost: een pakbon toevoegen kan niet meer.",
  "shipment.cmrReceived": "binnen {{day}}",
  "shipment.download": "Downloaden",

  "shipments.views": "Welke zendingen",
  "shipments.view.active": "Actief",
  "shipments.view.waiting": "Wacht op Willems",
  "shipments.view.delivered": "Afgeleverd",
  "shipments.view.all": "Alles",
  "shipments.search": "Referentie, ordernummer of plaats",
  "shipments.periodFrom": "Van",
  "shipments.periodTo": "Tot en met",
  "shipments.excel": "Excel",
  "shipments.col.shipment": "Zending",
  "shipments.col.from": "Van",
  "shipments.col.to": "Naar",
  "shipments.col.load": "Laden",
  "shipments.col.unload": "Lossen",
  "shipments.col.cargo": "Lading",
  "shipments.col.status": "Status",
  "shipments.col.cmr": "CMR",
  "shipments.pallets_one": "{{n}} pallet",
  "shipments.pallets_other": "{{n}} pallets",
  "shipments.cmrNotYet": "nog niet",
  "shipments.cmrNotYetLong": "CMR nog niet binnen",
  "shipments.cmrAvailable": "CMR",
  "shipments.cmrAvailableLong": "CMR binnen",
  "shipments.cmrDownload": "Afgetekende CMR van {{number}} downloaden",
  "shipments.pickOne": "{{number}} selecteren",
  "shipments.pickAll": "Alle zendingen in de lijst selecteren",
  "shipments.selected_one": "{{count}} geselecteerd",
  "shipments.selected_other": "{{count}} geselecteerd",
  "shipments.selectedWithCmr_one": "{{count}} met CMR",
  "shipments.selectedWithCmr_other": "{{count}} met CMR",
  "shipments.downloadCmrs": "CMR's downloaden",
  "shipments.clearSelection": "Selectie opheffen",
  "shipments.cmrZipMax": "Hoogstens {{max}} CMR's tegelijk; maak de selectie kleiner.",
  "shipments.more": "Meer tonen",
  "shipments.loadingMore": "Meer ophalen …",
  "shipments.notFound": "Niets gevonden voor “{{q}}” in {{view}}",
  "shipments.notFoundText": "Zoek in Alles om ook afgeleverde en geannuleerde zendingen mee te nemen.",
  "shipments.notFoundAll": "Probeer een ander woord of een andere periode.",
  "shipments.searchAll": "Zoeken in Alles",
  "columns.sortBy": "Sorteren op {{column}}",
  "columns.filterBy": "Filteren op {{column}}",
  "columns.filteredBy": "Gefilterd op {{column}}: klik om het filter te wijzigen",
  "columns.filterContains": "Bevat…",
  "columns.filterRangeFrom": "Van",
  "columns.filterRangeTo": "Tot en met",
  "columns.filterFrom": "vanaf {{value}}",
  "columns.filterUntil": "tot en met {{value}}",
  "columns.filterClear": "Wissen",
  "columns.filterDone": "Klaar",
  "columns.filteredOn": "Gefilterd op",
  "columns.filterRemove": "Filter op {{column}} weghalen",
  "columns.filterClearAll": "Alle filters wissen",
  "shipments.palletsUnit": "pallets",
  "shipments.notFiltered": "Geen zendingen met deze filters in {{view}}",
  "shipments.notFilteredText": "Haal een filter weg, of kijk in Alles.",
  "shipments.emptyTitle": "Nog geen zendingen",
  "shipments.emptyText": "Een order die u hier invoert of die via EDI binnenkomt, staat hier zodra Willems hem heeft.",
  "shipments.none.active": "Geen zendingen onderweg of op komst",
  "shipments.none.waiting": "Er wacht niets op Willems",
  "shipments.none.delivered": "Niets afgeleverd in deze periode",
  "shipments.none.all": "Geen zendingen in deze periode",


  "shipment.entered.portalBy": "Ingevoerd in het portaal door {{name}}, {{at}}",

  "order.steps": "Stappen",
  "order.step.stops": "Laden en lossen",
  "order.step.goods": "Lading",
  "order.step.documents": "Documenten",
  "order.step.check": "Controleren",
  "order.step.toFill": "nog in te vullen",
  "order.step.willWait": "wacht op Willems",
  "order.step.willConfirm": "meteen bevestigd",
  "order.step.more_one": "nog {{count}} zending",
  "order.step.more_other": "nog {{count}} zendingen",
  "order.step.lines_one": "{{count}} regel",
  "order.step.lines_other": "{{count}} regels",
  "order.step.cmrDefault": "uw bedrijf en het losadres",
  "order.step.slips_one": "{{count}} pakbon",
  "order.step.slips_other": "{{count}} pakbonnen",
  "order.step.cmrOther": "andere afzender of ontvanger",
  "order.titleChange": "Order {{number}} wijzigen",
  "order.forCompany": "Voor {{company}}",
  "order.reference": "Uw referentie",
  "order.referenceHelp": "Komt op de CMR en de factuur.",
  "order.required": "Vul dit in.",
  "order.optional": "(optioneel)",
  "order.consignmentN": "Zending {{n}}",
  "order.missing.stops": "Kies bij laden en lossen een adres en een datum; lossen is niet vóór laden.",
  "order.missing.address": "Kies hierboven een adres.",
  "order.missing.addressTyped": "Vul minstens de naam, de plaats en het land in.",
  "order.missing.date": "Kies een datum.",
  "order.missing.beforeLoad": "Lossen is niet vóór laden.",
  "order.missing.goods": "Geef bij elke regel een aantal, en de laadmeters bij rolcontainers, dozen en overige goederen. Een omschrijving mag, maar hoeft niet.",
  "order.address.name": "Naam",
  "order.address.street": "Straat",
  "order.address.houseNumber": "Huisnummer",
  "order.address.addition": "Toevoeging",
  "order.address.postalCode": "Postcode",
  "order.address.city": "Plaats",
  "order.address.country": "Land",
  "order.address.fromBook": "Kies uit uw adressen",
  "order.address.other": "Een ander adres kiezen",
  "order.address.search_one": "Zoek in uw {{count}} adres",
  "order.address.search_other": "Zoek in uw {{count}} adressen",
  "order.address.new": "Ander adres",
  "order.address.all_one": "Alle {{count}} adressen",
  "order.address.all_other": "Alle {{count}} adressen",
  "order.address.mostUsed": "meest gebruikt eerst",
  "order.address.noneFound": "Geen van uw adressen past bij wat u zoekt.",
  "order.hours.always": "altijd open",
  "order.hours.open": "open {{hours}}",
  "order.hours.closed": "dicht op die dag",
  "order.stop.load": "Laden",
  "order.stop.unload": "Lossen",
  "order.stop.newChip": "Nieuw adres",
  "order.stop.newShort": "nieuw",
  "order.stop.newWarning": "Nieuw adres: uw order wacht op Willems. Willems controleert een nieuw adres eerst en legt het vast; daarna gaat de order door.",
  "order.stop.date": "Datum",
  "order.stop.from": "Venster van",
  "order.stop.to": "tot",
  "order.stop.endsBeforeStart": "De eindtijd ligt vóór de begintijd. Pas de tijd aan, of vink hieronder aan dat het venster doorloopt tot de volgende dag.",
  "order.stop.nextDay": "Het venster loopt door tot de volgende dag",
  "order.stop.loadReference": "Referentie bij het laden",
  "order.stop.unloadReference": "Referentie bij het lossen",
  "order.stop.requirement": "Vervoerseis",
  "order.stop.requirementNone": "Geen",
  "order.stop.instruction": "Opmerking voor de chauffeur",
  "order.stop.contactName": "Contactpersoon",
  "order.stop.contactPhone": "Telefoon",
  "order.stopRequirement.tail_lift": "Laadklep",
  "order.stopRequirement.rigid_with_tail_lift": "Bakwagen met laadklep",
  "order.stopRequirement.no_rear_tail_lift": "Geen achterklep",
  "order.note.outside_hours": "Het venster valt buiten de openingstijden ({{hours}}). Willems kijkt ernaar; de order gaat gewoon door.",
  "order.note.closed_that_day": "Deze plek is die dag dicht. Willems kijkt ernaar; de order gaat gewoon door.",
  "order.note.window_in_past": "Deze dag is al voorbij.",
  "order.goods.titleTo": "Lading naar {{place}}",
  "order.goods.count": "Aantal",
  "order.goods.carrier": "Drager",
  "order.goods.description": "Goederenomschrijving",
  "order.goods.weight": "Gewicht (kg)",
  "order.goods.loadingMeters": "Laadmeters",
  "order.goods.removeLine": "Regel weghalen",
  "order.goods.addLine": "Nog een regel",
  "order.goods.requirements": "Vervoerseisen",
  "order.goods.together": "Samen",
  "order.goods.pallets_one": "{{n}} pallet",
  "order.goods.pallets_other": "{{n}} pallets",
  "order.goods.metres": "{{n}} m laadmeter",
  "order.goods.volume": "Kuub (m³)",
  "order.goods.volumeValue": "{{n}} m³",
  "order.goods.adrCode": "ADR-code",
  "order.goods.adrCodeChoose": "Kies de ADR-code",
  "order.goods.adrClass": "klasse {{value}}",
  "order.goods.adrPackingGroup": "Verpakkingsgroep",
  "order.goods.adrLines": "Gevaarlijke stoffen (ADR)",
  "order.goods.adrPackingGroupChoose": "Kies",
  "order.goods.adrQuantity": "Hoeveelheid",
  "order.goods.adrUnit": "Eenheid",
  "order.goods.adrAddLine": "Nog een ADR-stof",
  "order.goods.adrRemoveLine": "Regel weghalen",
  "order.goods.addConsignment": "Nog een zending in deze order, naar een ander adres",
  "order.goods.removeConsignment": "Zending weghalen",
  "order.carrier.europallet": "Europallet",
  "order.carrier.block_pallet": "Blokpallet 0,5 lm",
  "order.carrier.block_pallet_06": "Blokpallet 0,6 lm",
  "order.carrier.block_pallet_09": "Blokpallet 0,9 lm",
  "order.carrier.ibc_02": "IBC 0,2 lm",
  "order.carrier.ibc_04": "IBC 0,4 lm",
  "order.carrier.ibc": "IBC 0,5 lm",
  "order.carrier.ibc_06": "IBC 0,6 lm",
  "order.carrier.big_bag": "Big Bag 0,5 lm",
  "order.carrier.roll_container": "Rolcontainer",
  "order.carrier.box": "Colli of dozen",
  "order.carrier.other": "Overig",
  "order.carrier.own": "Uw dragers",
  "order.carrier.fixed": "Standaard",
  "order.cmr.title": "Op de CMR",
  "order.cmr.lead": "Afzender en ontvanger kunnen anders zijn dan het laad- en losadres.",
  "order.cmr.sender": "Afzender",
  "order.cmr.consignee": "Ontvanger",
  "order.cmr.yourCompany": "Uw bedrijf, zoals Willems het kent",
  "order.cmr.sameAsUnload": "Zelfde als het losadres",
  "order.cmr.theUnloadAddress": "het losadres",
  "order.cmr.other": "Een ander adres",
  "order.slip.label": "Pakbon",
  "order.slip.help": "Een pdf, bijvoorbeeld uw pakbon, tot 10 MB. U ziet hem terug bij de zending.",
  "order.slip.add": "Pakbon toevoegen",
  "order.slip.uploading": "Bezig met toevoegen…",
  "order.slip.remove": "{{name}} weghalen",
  "order.slip.tooLarge": "Dit bestand is groter dan 10 MB.",
  "order.slip.notPdf": "Alleen een pdf kan als pakbon.",
  "order.slip.tooMany": "Hoogstens {{max}} per zending.",
  "order.slip.failed": "Toevoegen lukte niet. Probeer het opnieuw.",
  "order.slip.gone": "Een pakbon was niet meer bij ons bekend. Voeg hem opnieuw toe en verstuur de order dan.",
  "order.check.title": "Zo gaat de order naar Willems",
  "order.check.change": "Wijzigen",
  "order.check.willWait": "Deze order wacht op Willems.",
  "order.rail.title": "Uw order",
  "order.rail.step": "stap {{n}}",
  "order.rail.loadN": "Laden {{n}}",
  "order.rail.unloadN": "Lossen {{n}}",
  "order.rail.goods": "Lading",
  "order.notice.title": "Voordat u verstuurt",
  "order.notice.newAddress": "Nieuw adres: de order wacht tot Willems het adres heeft gecontroleerd.",
  "order.notice.inTime": "Op tijd voor laden op {{load}}: invoeren kan tot {{until}}.",
  "order.notice.late": "Na de uiterste invoertijd ({{time}} de dag vóór het laden). Willems bekijkt of het nog lukt.",
  "order.notice.referenceTaken": "Uw referentie staat al op order {{order}}. Kies een andere.",
  "order.savedAt": "Concept bewaard om {{time}}",
  "order.notSavedYet": "Wordt bewaard terwijl u typt",
  "order.saveAndClose": "Opslaan en sluiten",
  "order.previous": "Vorige",
  "order.next": "Volgende: {{step}}",
  "order.send": "Order versturen",
  "order.sendChange": "Wijziging versturen",
  "order.sendAgain": "Opnieuw versturen",
  "order.sending": "Versturen …",
  "order.failure.title": "Versturen lukte niet",
  "order.failure.text": "Uw order is niet verstuurd; wat u invoerde staat er nog. Probeer het opnieuw. Lukt het niet, neem dan contact op met uw contactpersoon.",
  "order.failure.textCode": "Uw order is niet verstuurd; wat u invoerde staat er nog. Probeer het opnieuw. Lukt het niet, noem dan code {{code}} aan uw contactpersoon.",
  "order.error.too_many_pallets": "Samen meer dan 99 palletplaatsen in één zending. Verdeel de lading over meer zendingen.",
  "order.error.too_heavy": "Samen meer dan 60.000 kg in één zending. Verdeel de lading over meer zendingen.",
  "order.error.too_long": "Samen meer dan 30 laadmeter in één zending. Verdeel de lading over meer zendingen.",
  "order.sent.at": "Verstuurd om {{time}}",
  "order.sent.changedAt": "Gewijzigd om {{time}}",
  "order.sent.title": "Order {{number}} is bij Willems",
  "order.sent.changedTitle": "Order {{number}} is gewijzigd",
  "order.sent.confirmed": "Willems heeft de order en plant hem in.",
  "order.sent.toShipment": "Naar de zending",
  "order.sent.another": "Nog een order invoeren",
  "order.sent.sameAgain": "Dezelfde order voor een andere dag",
  "order.earlier.open": "Begin met een eerdere order",
  "order.earlier.title": "Begin met een eerdere order",
  "order.earlier.lead": "Het portaal neemt adressen, vensters, lading en vervoerseisen over. De datums en uw referentie vult u zelf in.",
  "order.earlier.search": "Zoek op order, uw referentie of plaats",
  "order.earlier.order": "Order",
  "order.earlier.route": "Route",
  "order.earlier.take": "Deze nemen",
  "order.earlier.none": "Geen orders gevonden.",
  "order.notAvailable": "Orders invoeren kan in het portaal voor een klant van Willems. Neem contact op met uw contactpersoon.",
  "order.notChangeable.closed": "Deze order is afgewezen of geannuleerd en kan niet meer gewijzigd worden.",
  "order.notChangeable.elsewhere": "Deze order is niet in het portaal ingevoerd. Wijzigen kan langs de weg waarop hij binnenkwam, of via uw contactpersoon bij Willems.",
  "order.notChangeable.planned": "Deze order is ingepland. Wijzigen kan nu alleen via uw contactpersoon bij Willems.",
  "order.notChangeable.pending": "Willems verwerkt nog een wijziging van deze order. Probeer het later opnieuw, of neem contact op met uw contactpersoon.",
  "order.notChangeable.transition": "Deze order is ingevoerd vóór 1 december. Wijzigen of annuleren kan via uw contactpersoon bij Willems.",
  "order.change": "Wijzigen",
  "order.changeUntil": "Kan tot de zending is ingepland.",
  "order.again": "Opnieuw invoeren voor een andere dag",
  "order.cancel.open": "Annuleren",
  "order.cancel.title": "Order {{number}} annuleren",
  "order.cancel.lead": "De hele order wordt geannuleerd, met alle zendingen erin. Willems leest uw reden.",
  "order.cancel.reason": "Waarom annuleert u?",
  "order.cancel.back": "Terug",
  "order.cancel.confirm": "Order annuleren",
  "order.cancel.tooLate": "Deze order kan niet meer geannuleerd worden in het portaal. Neem contact op met uw contactpersoon.",

  "error.loginFailed": "E-mailadres of wachtwoord klopt niet. Let op hoofdletters. Na vijf keer gaat inloggen een kwartier dicht.",
  "error.locked": "Uw account is een kwartier dicht na vijf pogingen die niet klopten. Het kan weer om {{time}}.",
  "error.codeWrong": "Deze code klopt niet. Typ de code die nu in de app staat.",
  "error.setupIncomplete": "Uw account is nog niet ingesteld. Gebruik de link in de uitnodiging; werkt die niet meer, vraag dan uw contactpersoon bij Willems om een nieuwe.",
  "error.linkInvalid": "Deze link werkt niet meer.",
  "error.currentPasswordWrong": "Dit wachtwoord klopt niet.",
  "error.signInAgain": "Dat duurde te lang. Log opnieuw in.",
  "error.secondFactorOff": "De koppeling met de app is hier nog niet mogelijk. Neem contact op met uw contactpersoon bij Willems.",
  "error.tooMany": "Te veel pogingen vanaf dit adres. Wacht een minuut en probeer het opnieuw.",
  "error.generic": "Er ging iets mis. Probeer het zo opnieuw.",

  // Voorraad (H-v01 … H-v06, step 7).
  "stock.asOf": "Stand van",
  "stock.inWarehouse": "magazijn {{name}}",
  "stock.inWarehouses_one": "{{count}} magazijn",
  "stock.inWarehouses_other": "{{count}} magazijnen",
  "stock.fetching": "Stand wordt opgehaald",
  "stock.noStand": "Geen stand",
  "stock.refresh": "Vernieuwen",
  "stock.excel": "Excel per pallet",
  "stock.views": "Welke artikelen",
  "stock.view.all": "Alle artikelen",
  "stock.view.short": "THT korter dan 9 maanden",
  "stock.view.blocked": "Geblokkeerd",
  "stock.search": "Artikel, batch, SSCC of LHC",
  "stock.searchShort": "Zoek een artikel",
  "stock.owner": "Eigenaar",
  "stock.allOwners": "Alle eigenaren",
  "stock.warehouse": "Magazijn",
  "stock.allWarehouses": "Alle magazijnen",
  "stock.loading": "Voorraad ophalen uit het magazijn. Dit duurt een paar seconden.",
  "stock.failedTitle": "De voorraad is nu niet op te halen.",
  "stock.failedText": "Probeer het over een paar minuten opnieuw. Een oudere stand tonen we niet: die kan niet meer kloppen.",
  "stock.failedCode": "Blijft het mislukken? Noem dan code {{code}} aan uw contactpersoon bij Willems.",
  "stock.busyTitle": "Het is even druk.",
  "stock.busyText": "Er wordt nu veel voorraad opgevraagd. Probeer het over een minuut opnieuw.",
  "stock.refreshIn": "Vernieuwen over {{seconds}} s",
  "stock.retryIn": "Opnieuw over {{seconds}} s",
  "stock.emptyTitle": "U heeft nu geen voorraad bij Willems.",
  "stock.emptyText": "Zodra er pallets binnen zijn, staan ze hier.",
  "stock.notFound": "Niets gevonden voor “{{q}}”.",
  "stock.none.all": "Geen artikelen met deze filters.",
  "stock.none.short": "Geen pallets met een THT korter dan 9 maanden.",
  "stock.none.blocked": "Geen geblokkeerde pallets.",
  "stock.showAll": "Alles tonen",
  "stock.col.article": "Artikel",
  "stock.col.total": "Totaal",
  "stock.col.free": "Vrij",
  "stock.col.reserved": "Gereserveerd",
  "stock.col.blocked": "Geblokkeerd",
  "stock.col.shortest": "THT (kortste)",
  "stock.col.bestBefore": "THT",
  "stock.col.sscc": "SSCC",
  "stock.col.batch": "Batch",
  "stock.col.lhc": "LHC",
  "stock.col.quantity": "Aantal",
  "stock.col.status": "Status",
  "stock.col.received": "Ontvangen",
  "stock.shortPallets_one": "{{count}} pallet < 9 mnd",
  "stock.shortPallets_other": "{{count}} pallets < 9 mnd",
  "stock.months_one": "{{count}} mnd",
  "stock.months_other": "{{count}} mnd",
  "stock.palletsWhere": "in {{where}} · geblokkeerd eerst, dan de kortste THT",
  "stock.status.free": "Vrij",
  "stock.status.reserved": "Gereserveerd",
  "stock.status.blocked": "Geblokkeerd",
  "stock.split": "Vrij {{free}}, gereserveerd {{reserved}}, geblokkeerd {{blocked}}",
  "stock.freeShort": "Vrij {{n}}",
  "stock.reservedShort": "Geres. {{n}}",
  "stock.blockedShort": "Geblokk. {{n}}",

  // Uitleveren en Aanleveren (H-w01 … H-w03, step 8).
  "warehouseOrder.kindLabel": "Soort order",
  "warehouseOrder.kind.transport": "Alleen transport",
  "warehouseOrder.kind.outbound": "Uitleveren uit ons magazijn",
  "warehouseOrder.kind.inbound": "Aanleveren in ons magazijn",
  "warehouseOrder.kindShort.transport": "Transport",
  "warehouseOrder.kindShort.outbound": "Uitleveren",
  "warehouseOrder.kindShort.inbound": "Aanleveren",
  "warehouseOrder.loading": "Uw artikelen en magazijnen ophalen.",
  "warehouseOrder.noWarehouse": "Er ligt nu geen voorraad van u bij Willems.",
  "warehouseOrder.noWarehouseText": "Wilt u iets aanleveren voor een nieuw artikel? Neem contact op met uw contactpersoon bij Willems.",
  "warehouseOrder.articles": "Artikelen",
  "warehouseOrder.ownArticles_one": "{{count}} van uw artikelen",
  "warehouseOrder.ownArticles_other": "{{count}} van uw artikelen",
  "warehouseOrder.unit": "Eenheid",
  "warehouseOrder.uom.PCE_one": "stuk",
  "warehouseOrder.uom.PCE_other": "stuks",
  "warehouseOrder.uom.ST_one": "stuk",
  "warehouseOrder.uom.ST_other": "stuks",
  "warehouseOrder.uom.CT_one": "doos",
  "warehouseOrder.uom.CT_other": "dozen",
  "warehouseOrder.uom.BX_one": "doos",
  "warehouseOrder.uom.BX_other": "dozen",
  "warehouseOrder.uom.BG_one": "zak",
  "warehouseOrder.uom.BG_other": "zakken",
  "warehouseOrder.uom.BD_one": "bundel",
  "warehouseOrder.uom.BD_other": "bundels",
  "warehouseOrder.uom.KT_one": "kit",
  "warehouseOrder.uom.KT_other": "kits",
  "warehouseOrder.uom.PF_one": "pallet",
  "warehouseOrder.uom.PF_other": "pallets",
  "warehouseOrder.uom.KGM_one": "kilo",
  "warehouseOrder.uom.KGM_other": "kilo",
  "warehouseOrder.stockAsOf": "Voorraad: stand van {{time}}",
  "warehouseOrder.stockFailed": "De voorraad is nu niet op te halen. U kunt het artikelnummer zelf invullen.",
  "warehouseOrder.stockLoading": "Voorraad ophalen…",
  "warehouseOrder.chooseOwner": "Kies een eigenaar",
  "warehouseOrder.article": "Artikel",
  "warehouseOrder.searchArticle": "Typ een artikelnummer of omschrijving",
  "warehouseOrder.noArticleFound": "Geen artikel gevonden",
  "warehouseOrder.moreArticles_one": "Nog {{count}} artikel: typ verder om te zoeken",
  "warehouseOrder.moreArticles_other": "Nog {{count}} artikelen: typ verder om te zoeken",
  "warehouseOrder.freeShort": "vrij {{n}} {{unit}}",
  "warehouseOrder.notListed": "Geen artikel uit de lijst: kies het artikel",
  "warehouseOrder.quantity": "Aantal {{unit}}",
  "warehouseOrder.batch": "Batch",
  "warehouseOrder.pallets": "Pallets",
  "warehouseOrder.choosePallets": "Kies pallets",
  "warehouseOrder.palletsChosen_one": "{{count}} pallet",
  "warehouseOrder.palletsChosen_other": "{{count}} pallets",
  "warehouseOrder.palletsHint": "Vink de pallets aan die u wilt laten uitleveren. Het aantal wordt wat erop staat.",
  "warehouseOrder.palletsHintBatch": "Vink de pallets met batch {{batch}} aan die u wilt laten uitleveren. Het aantal wordt wat erop staat.",
  "warehouseOrder.noPalletsOfBatch": "Er zijn geen vrije pallets met deze batch.",
  "warehouseOrder.palletNumber": "Palletnr. {{n}}",
  "warehouseOrder.bestBefore": "THT {{date}}",
  "warehouseOrder.perPallet": "Per pallet",
  "warehouseOrder.removeLine": "Weghalen",
  "warehouseOrder.moreThanFree": "Meer dan er vrij is ({{free}} {{unit}}). U kunt het toch versturen; Willems neemt contact met u op.",
  "warehouseOrder.addLine": "Artikel toevoegen",
  "warehouseOrder.howOut": "Hoe gaat het weg uit {{warehouse}}?",
  "warehouseOrder.howIn": "Hoe komt het naar {{warehouse}}?",
  "warehouseOrder.transport.outbound.willems": "Willems levert het af",
  "warehouseOrder.transport.outbound.customer": "Het wordt afgehaald",
  "warehouseOrder.transport.inbound.willems": "Willems haalt het op",
  "warehouseOrder.transport.inbound.customer": "Het wordt gebracht",
  "warehouseOrder.dayOut": "Dag dat het uit ons magazijn gaat",
  "warehouseOrder.dayIn": "Dag dat het aankomt",
  "warehouseOrder.load": "Wat er mee gaat",
  "warehouseOrder.remark": "Opmerking voor het magazijn",
  "warehouseOrder.orderLabel": "Uw order",
  "warehouseOrder.deliverTo": "Afleveren bij",
  "warehouseOrder.collectedAddressHint": "Waar gaan de goederen heen? Dat komt op de vrachtbrief (CMR).",
  "warehouseOrder.collectFrom": "Ophalen bij",
  "warehouseOrder.forWarehouse": "Voor het magazijn",
  "warehouseOrder.vas": "VAS",
  "warehouseOrder.vasOrder": "VAS voor de hele order",
  "warehouseOrder.vasLine": "VAS voor {{article}}",
  "warehouseOrder.vasChoose": "Kies",
  "warehouseOrder.beforeSending": "Voordat u verstuurt: van {{articles}} vraagt u meer dan er vrij is. Willems neemt contact met u op.",
  "warehouseOrder.send": "Order versturen",
  "warehouseOrder.sending": "Versturen…",
  "warehouseOrder.sent.title": "Order {{number}} is verstuurd",
  "warehouseOrder.sent.withTransport": "Het magazijn zet het klaar en Willems rijdt het. U volgt de zending bij Zendingen.",
  "warehouseOrder.sent.withoutTransport": "Het magazijn heeft uw order. Willems neemt contact met u op als er iets niet klopt.",
  "warehouseOrder.sent.toShipment": "Naar de zending",
  "warehouseOrder.sent.another": "Nog een order",
  "warehouseOrder.sent.toOrders": "Naar uw magazijnorders",

  "warehouseOrders.lead": "Uw uitleveringen en aanleveringen van de laatste 90 dagen, ook wat wordt afgehaald of gebracht.",
  "warehouseOrders.loading": "Uw magazijnorders ophalen.",
  "warehouseOrders.views": "Welke orders",
  "warehouseOrders.view.all": "Alles",
  "warehouseOrders.view.outbound": "Uitleveren",
  "warehouseOrders.view.inbound": "Aanleveren",
  "warehouseOrders.search": "Referentie, ordernummer of artikel",
  "warehouseOrders.searchShort": "Zoeken",
  "warehouseOrders.col.order": "Uw referentie",
  "warehouseOrders.col.kind": "Soort",
  "warehouseOrders.col.warehouse": "Magazijn",
  "warehouseOrders.col.day": "Dag",
  "warehouseOrders.col.transport": "Vervoer",
  "warehouseOrders.col.articles": "Artikelen",
  "warehouseOrders.col.status": "Status",
  "warehouseOrders.col.quantity": "Aantal",
  "warehouseOrders.col.pallet": "Pallet",
  "warehouseOrders.moreArticles_one": "en {{count}} ander artikel",
  "warehouseOrders.moreArticles_other": "en {{count}} andere artikelen",
  "warehouseOrders.status.sent": "Verstuurd",
  "warehouseOrders.status.received": "Bij het magazijn",
  "warehouseOrders.status.waiting": "Willems kijkt ernaar",
  "warehouseOrders.deliveryDay": "Gewenste afleverdag",
  "warehouseOrders.goesTo": "Gaat naar",
  "warehouseOrders.enteredPortal": "Ingevoerd in het portaal op {{at}}",
  "warehouseOrders.enteredWillems": "Ingevoerd door Willems op {{at}}",
  "warehouseOrders.emptyTitle": "Nog geen magazijnorders",
  "warehouseOrders.emptyText": "Een uitlevering of aanlevering die u invoert, staat hier.",
  "warehouseOrders.notFound": "Niets gevonden voor “{{q}}”",
  "warehouseOrders.none.all": "Geen magazijnorders",
  "warehouseOrders.none.outbound": "Geen uitleveringen",
  "warehouseOrders.none.inbound": "Geen aanleveringen",
  "warehouseOrders.transport.willems": "Met Willems",
  "warehouseOrders.transport.customer": "Afhalen of brengen",
  "warehouseOrders.notFiltered": "Geen magazijnorders met deze filters",
  "warehouseOrders.showAll": "Alles tonen",
};

export type Messages = Record<keyof typeof nl, string>;
